export default __webpack_public_path__ + "static/media/pills@3x.37e23eb7.png";